<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="!isLoading()">
  <div class="container-fluid  p-0">
    <div class="row m-t-xs">
      <div class="col-12">
        <p-panel>
          <div class="row">
            <div class="col-12">
              <input type="text" class="p-inputtext w-100" placeholder="{{ 'Documents.write.filter' | translate }}"
                name="filterText" id="filterTextInput" autocomplete="off" [(ngModel)]="filterText"
                (ngModelChange)="updateFilter()" />
            </div>
          </div>
          <p-table [value]="filteredReports" sortField="startInfo.date" sortOrder="1" [rows]="20" [paginator]="false"
            [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]"
            class="footer-over-pagination  mb-3 table table-striped table-hover ">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="col-icon"></th>
                <th class="" style="width:80%"></th>
                <th class="action-column-2x"></th>
                <!-- <th class="action-column"></th> -->
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-report let-rowIndex="rowIndex">
              <tr class="ui-widget-header m-t-md" *ngIf="rowGroupMetadata[report.group].index === rowIndex">
                <td colspan="3" class="p-t-3">
                  <strong>{{ report.group }}</strong>
                </td>
              </tr>
              <tr>
                <td class="col-icon">
                  <a (click)="openReport(report)">
                    <span><i class="fa fa-chart-bar fa-lg"></i><span class="sr-only"></span>
                    </span>
                  </a>
                </td>
                <td>
                  <a (click)="openReport(report)">{{ report.description }}</a>
                </td>
                <!--td class="action-column-2x">
                  <div class="btn-group">
                    <button class="btn btn-sm btn-primary t-action-button" [attr.visible]="!isEditing() ? 'true' : null"  aria-expanded="false" (click)="delete(report)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>

                    <button class="btn btn-sm btn-primary t-action-button" [attr.visible]="!isEditing() ? 'true' : null"  aria-expanded="false" (click)="editReport(report)">
                      <i class="fas fa-pencil-alt"  aria-hidden="true"></i>
                    </button>
                  </div>
                </td>-->
                <td class="action-column-2x">
                  <div class="btn-group">
                    <ng-container *ngFor="let action of report.availableActions?.actions">
                      <button *ngIf="action.identifier === 'DELETE_REPORT'"
                        class="btn btn-sm btn-primary t-action-button" [attr.visible]="!isEditing() ? 'true' : null"
                        aria-expanded="false" (click)="delete(report)" title="{{ 'General.delete' | translate }}">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                      <button *ngIf="action.identifier === 'MODIFY_REPORT'"
                        class="btn btn-sm btn-primary t-action-button" [attr.visible]="!isEditing() ? 'true' : null"
                        aria-expanded="false" (click)="editReport(report)" title="{{ 'General.edit' | translate }}">
                        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                      </button>
                      <button *ngIf="action.identifier === 'EDIT_REPORT'" class="btn btn-sm btn-primary t-action-button"
                        [attr.visible]="!isEditing() ? 'true' : null" aria-expanded="false"
                        (click)="editReportPentaho(report)" title="{{ 'General.edit' | translate }}">
                        <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                      </button>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="text-center">
                <td colspan="3"> {{ "General.noFilteredData" | translate }} </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
  <!-- <div class="container-fluid ">
    <div class="row">
      <div class="col-12">
      </div>
    </div>
  </div> -->
</div>
<ng-container *ngIf="selectedReport">
  <p-dialog [header]="selectedReport.name" modal="true" [(visible)]="displayDialog" blockScroll="true" responsive="true"
    [style]="{ width: '80%' }">
    <div class="wrapper wrapper-content ng-scope animated fadeInRight" style="    height: 99vh;">
      <div class="container-fluid  p-0">
        <div class="row m-t-xs">
          <div class="col-12">
            <blockquote>{{ selectedReport.description }}</blockquote>
          </div>
        </div>
        <div class="row m-t-xs">
          <div class="col-12">
            <iframe class="e2e-iframe-untrusted-src w-100 vh-100 " [src]="sanitizedURL" frameborder="0" allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-container>